import { AgGridReact } from 'ag-grid-react';
import _, { isEmpty } from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  ehrAPIBaseService,
  singleFileDownloadUrlGenerator,
  singleFileDownloadUrlGeneratorFromFhirUrl,
} from '../../../../http-common';
import dayjs from 'dayjs';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../MainUIFrame/MainFrame';
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  ACTION_MAIN_BOTTOM_BAR_JSX,
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
  ACTION_OPEN_TOOLBAR,
  ACTION_RESET,
  ACTION_RIGHT_DRAWER,
  ACTION_LEFT_DRAWER,
  ACTION_RIGHT_DRAWER_JSX,
  ACTION_SET_APPBAR_JSX,
  ACTION_SET_TOOLBAR_JSX,
} from '../../../MainUIFrame/constants';
import EHRToolbar from '../../../Toolbar/toolbarContent';
import EHRBottomBar from '../../../../pages/Practitioner/contents/bottomBarContent';
import { useDispatch } from 'react-redux';
import { setToolbarButtons } from '../../../../redux/features/toolbarSlice';
import { toolbarConstants } from '../../../../constants/toolbar/toolbarConstants';
import jwtDecode from 'jwt-decode';
import { getFileExtensionAndMimeTypeFromUrl } from '../../../../config/common';
import { useParams } from 'react-router-dom';
import ExportPatientDialog from '../../../../pages/ehr/pages/exportPatient/ExportPatientDialog';
import ExportAllPatient from '../../../../pages/ehr/pages/exportPatient/ExportAllPatient';

const Jobs = props => {
  const dispatch = useMainFrameDispatch();
  const gridRef = useRef(null);
  const gridStyle = useMemo(() => ({ width: '100%' }), []);
  const { isDark } = useMainFrameState();

  const query = useParams();

  const [currentSelectedRow, setCurrentSelectedRow] = useState(null);
  const [renderGrid, setRenderGrid] = useState(0);

  const gridRefreshCallback = useCallback(() => {
    gridRef?.current?.api?.setDatasource(dataSource());
  }, [renderGrid]);

  const getBadgeStyle = badgeColor => ({
    backgroundColor: badgeColor,
    color: 'white', // Text color
    padding: '4px 8px',
    borderRadius: '6px',
  });

  const reduxDispatch = useDispatch();
  const renderCellWithDash = params => {
    const fieldValue = params.data && params.data[params.colDef.field];
    if (fieldValue === null || fieldValue === '') {
      return '-';
    }
    return fieldValue;
  };

  const columnData = [
    {
      headerName: 'Job Name',
      field: 'jobName',
      flex: 1,
      // cellRenderer: renderCellWithDash,
      cellRenderer: params => {
        if (
          params?.data?.jobName &&
          params?.data?.jobName !== 'No Data Found'
        ) {
          return params?.data?.jobName;
        }

        if (params?.value === 'No Data Found') {
          return <div>No Data Found</div>;
        }

        if (!isEmpty(params?.data) && params?.data?.jobName === undefined) {
          return <div style={{ fontSize: '9px' }}>Data Not Available</div>;
        }

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
              marginTop: 1,
            }}
          >
            <CircularProgress
              sx={{ display: 'flex' }}
              style={{ marginRight: 10 }}
              size={20}
            />
            <Typography> Loading...</Typography>
          </Box>
        );
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      flex: 1,
      cellRendererFramework: ({ value, data }) => {
        let badgeContent;
        let badgeColor;

        switch (value) {
          case 'completed':
            badgeContent = 'Completed';
            badgeColor = '#2E7D32';
            break;
          case 'received':
            badgeContent = 'Received';
            badgeColor = '#ED6C02';
            break;
          case 'in-progress':
            badgeContent = 'In-Progress';
            badgeColor = '#757de8';
            break;
          case 'failed':
            badgeContent = 'Failed';
            badgeColor = '#B32613';
          default:
            break;
        }
        return <span style={getBadgeStyle(badgeColor)}>{badgeContent}</span>;
      },
    },
    {
      headerName: 'Requested on',
      field: 'createdDate',
      flex: 1,
      cellRenderer: renderCellWithDash,
    },
    {
      headerName: 'Available from',
      field: 'exportedDate',
      flex: 1,
      cellRenderer: renderCellWithDash,
    },
    {
      headerName: 'File',
      field: 'file',
      flex: 1,
      cellRenderer: params => {
        if (!params?.data || params?.data?.jobName === 'No Data Found') {
          return null;
        }

        return (
          <>
            {params?.data?.status === 'completed' ? (
              <a
                href={params?.data?.downloadURL}
                style={{
                  cursor: 'pointer !important',
                  textDecoration: 'underline',
                  color: '#387ca3',
                }}
                download={'fileName'}
              >
                Download
              </a>
            ) : params?.data?.status !== 'failed' ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <CircularProgress size={20} />
                  &ensp;
                  <span>Export in progress...</span>
                </div>
              </>
            ) : (
              '-'
            )}
          </>
        );
      },
    },
  ];

  const onGridReady = params => {
    params.api.setDatasource(dataSource());
  };

  const AppBarJsx = () => {
    return (
      <Grid container>
        <Grid
          sx={{
            display: 'flex',
            alignItems: 'baseline',
            gap: 1,
            color: 'primary',
          }}
          item
          xs={12}
        >
          <Typography
            sx={{
              color: 'appBarIcon',
            }}
            variant="h5"
          >
            Exports
          </Typography>
        </Grid>
      </Grid>
    );
  };

  useEffect(() => {
    dispatch({ type: ACTION_OPEN_TOOLBAR });
    dispatch({ type: ACTION_LEFT_DRAWER });
    dispatch({
      type: ACTION_SET_TOOLBAR_JSX,
      payload: <EHRToolbar />,
    });
    if (!query?.id) {
      debugger;
      dispatch({ type: ACTION_SET_APPBAR_JSX, payload: <AppBarJsx /> });
    }
    dispatch({
      type: ACTION_MAIN_BOTTOM_BAR_JSX,
      payload: <EHRBottomBar />,
    });
  }, []);

  const handleOnClickView = () => {
    const link = document.createElement('a');
    link.href = currentSelectedRow?.downloadURL;
    link.download = 'desired-filename.ext';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const patientId = query?.id;
    reduxDispatch(
      setToolbarButtons({
        actions: [
          {
            key: toolbarConstants.EXPORT,
            clickAction: () => {
              openExportDialog();
            },
            disabled: patientId,
          },
          {
            key: toolbarConstants.REFRESH,
            clickAction: () => {
              gridRefreshCallback();
            },
          },
          {
            key: toolbarConstants.DOWNLOAD,
            clickAction: () => {
              handleOnClickView('openRecord');
            },
            disabled:
              !currentSelectedRow || currentSelectedRow?.status !== 'completed',
          },
        ],
        module: '',
        editSwitch: false,
      })
    );
    return () => reduxDispatch(setToolbarButtons({ actions: [] }));
  }, [currentSelectedRow]);

  const openExportDialog = () => {
    dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
    dispatch({ type: ACTION_RIGHT_DRAWER });
    dispatch({
      type: ACTION_RIGHT_DRAWER_JSX,
      payload: (
        <ExportAllPatient
          gridRefreshCallback={gridRefreshCallback}
          renderGrid={renderGrid}
          setRenderGrid={setRenderGrid}
        />
      ),
    });
  };

  let realTotalPage = 0;

  let openPageToken = '';

  const dataSource = () => {
    return {
      async getRows(params) {
        const { startRow, endRow, filterModel, sortModel } = params;
        // const patientId = props?.patientId; //
        const patientId = query?.id;
        let url = `fhir/search/`;
        let _resourseType = `?resourceType=Task&code=http://enliv.com/code/task-type|${
          patientId ? 'single-patient-export' : 'all-patient-export'
        }${patientId ? `&patient=${patientId}` : ''}`;
        let _pageToken = `_page_token=${openPageToken}`;
        let _offset = `_offset=${parseInt(startRow)}`;
        let _count = `_count=${parseInt(endRow - startRow)}`;
        let _sort = `_sort=-lastUpdated`;

        url += `${_resourseType}&${_offset}&${_count}&${_sort}`;

        if (!_.isEmpty(openPageToken) && endRow > 10) {
          url += `&${_pageToken}`;
        }

        let tempRows = [];

        try {
          const response = await ehrAPIBaseService.get(url);
          tempRows = response?.data?.entry?.map(singleResponse => {
            const data = singleResponse?.resource;

            // debugger;
            const fileMeta =
              data?.status === 'completed'
                ? getFileExtensionAndMimeTypeFromUrl(
                    data?.output?.[0]?.valueString
                  )
                : '';
            return {
              jobName: data?.description || '-',
              status: data?.status,
              createdDate: dayjs(data?.authoredOn).format(
                'MM/DD/YYYY HH:mm:ss'
              ),
              exportedDate:
                data?.status === 'completed'
                  ? dayjs(data?.executionPeriod?.end).format(
                      'MM/DD/YYYY HH:mm:ss'
                    )
                  : '-',
              fileUrl:
                data?.status === 'completed'
                  ? data?.output?.[0]?.valueString
                  : 'sdf',
              downloadURL:
                data?.status === 'completed'
                  ? singleFileDownloadUrlGeneratorFromFhirUrl({
                      fileNameUrl: encodeURIComponent(
                        data?.output?.[0]?.valueString
                      ),
                      type: fileMeta,
                    })
                  : '',
              fileName:
                data?.status === 'completed'
                  ? data?.output?.[0]?.valueString?.split('/')?.[1]
                  : '',
            };
          });

          // for (let obj of response?.data?.link) {
          //   if (obj?.relation === 'next') {
          //     let tempPageToken = obj?.url?.split('_page_token=')?.[1];
          //     openPageToken = tempPageToken;
          //   }
          // }

          if (tempRows?.length > 0) {
            params.successCallback(
              tempRows,
              realTotalPage === 0 ? response?.data?.total : realTotalPage
            );
          } else {
            params.successCallback([{ jobName: 'No Data Found' }], 1);
          }

          if (realTotalPage === 0) {
            realTotalPage = response?.data?.total;
          }

          for (let obj of response?.data?.link) {
            if (obj?.relation === 'next') {
              let tempPageToken = obj?.url?.split('_page_token=')?.[1];
              openPageToken = tempPageToken;
            }
          }
        } catch (e) {
          console.error(e);
          params.successCallback([{ jobName: 'No Data Found' }], 1);
        } finally {
        }

        // params.successCallback(tempRows, 8);
      },
    };
  };

  return (
    <>
      <Grid container>
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        ></Grid>
        <Grid item xs={12}>
          <div
            style={gridStyle}
            className={
              isDark
                ? 'ag-theme-custom overflow-grid pm-0'
                : 'ag-theme-alpine overflow-grid pm-0'
            }
          >
            <AgGridReact
              domLayout="autoHeight"
              ref={gridRef}
              columnDefs={columnData}
              rowSelection={'single'}
              paginationPageSize={10}
              rowModelType="infinite"
              cacheBlockSize={10}
              cacheOverflowSize={2}
              maxConcurrentDatasourceRequests={2}
              infiniteInitialRowCount={1}
              maxBlocksInCache={2}
              pagination={true}
              animateRows={true}
              onGridReady={onGridReady}
              suppressMovableColumns
              onSelectionChanged={param => {
                const selectedRowData =
                  gridRef?.current?.api?.getSelectedRows();
                let sRow =
                  selectedRowData.length > 0 &&
                  selectedRowData[selectedRowData.length - 1];
                if (sRow?.jobName !== 'No Data Found') {
                  setCurrentSelectedRow(sRow);
                }
              }}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default Jobs;
